<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">
          <a-form-model-item prop="title">
            <a-input v-model="form.title" class="search-input" placeholder="请输入案例标题"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="work_type">
            <a-select v-model="form.work_type" placeholder="请选择作业类型" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop">
              <a-select-option v-for="(item, index) in workArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item prop="term">
            <a-select placeholder="请选择实践学期" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.term">
              <a-select-option v-for="(item, index) in activityTerm" :key="index" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item prop="course_id">
            <a-select placeholder="请选择实践课程" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.course_id">
              <a-select-option v-for="(item, index) in trainCourse" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="class_id">
            <a-select show-search notFoundContent="暂无匹配班级" option-filter-prop="children" placeholder="请选择实践班级" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.class_id">
              <a-select-option v-for="(item, index) in activityClass" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item prop="teacher_name">
            <a-input style="width:160px" class="search-input" placeholder="请输入负责教师" v-model="form.teacher_name"></a-input>
          </a-form-model-item>

          <a-form-model-item prop="status">
            <a-select v-model="form.status" placeholder="请选择状态" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop">
              <a-select-option v-for="(item, index) in statusArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm">重置</a-button>
          </a-form-model-item>
        </a-form-model>
        <a-form-model-item style="margin-bottom: 0;">
          <a-button class="search-btn" type="primary" @click="downloadExcellent">批量下载视频</a-button>
        </a-form-model-item>
      </div>

      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" :bordered="false" size="small" rowKey="id" :pagination="false">
          <template slot="work_type" slot-scope="text, scope">
            {{scope.work_type == 1 ?  '大学生微电影' : '大学生讲思政课'}}
          </template>
          <template slot="status" slot-scope="text, scope">
            {{scope.status == 1 ?  '公开' : '隐藏'}}
          </template>
          <template slot="action" slot-scope="row, scope">
            <a-button type="link" style="padding: 0 5px;" @click="linkExcellent(scope)">访问</a-button>
            <a-button type="link" style="padding: 0 5px;" @click="editExcellent(scope)">编辑</a-button>
            <a-button type="link" style="padding: 0 5px;" @click="deleteExcellent(scope)">删除</a-button>
            <template v-if="appsUserInfo.user_type == 2 || (appsUserInfo.user_type == 1 &&  appsUserInfo.role_ids == 2 )">
              <a-button type="link" style="padding: 0 5px;" @click="changeExcellent(scope)">设为{{scope.status == 2 ? '公开' : '隐藏'}}</a-button>
            </template>
            <a-button type="link" style="padding: 0 5px;" @click="downloadExcellent(scope)">下载视频</a-button>

          </template>
        </a-table>

        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
      </div>
    </div>

    <!-- 下载进度 -->
    <a-spin :tip="`下载中 ${downloadProgress}% ...`" :spinning="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>

    <!-- 确认删除框 -->
    <CommonModal v-model="deleteVisible" title="确认删除" confirmText="确定" @confirm="submitDelete">
      <div>
        确认删除吗？
      </div>
    </CommonModal>

    <!-- 确认隐藏框 -->
    <CommonModal v-model="hideVisible" title="确认隐藏" confirmText="确定" @confirm="submitChangeStatus(2)">
      <div>
        确认隐藏吗？隐藏后本校师生不可查看此案例。
      </div>
    </CommonModal>

    <!-- 确认公开框 -->
    <CommonModal v-model="openVisible" title="确认公开" confirmText="确定" @confirm="submitChangeStatus(1)">
      <div>
        确认公开吗？公开后本校师生可查看此案例。
      </div>
    </CommonModal>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Bread from "../../../components/school/Bread.vue";
import CommonModal from "../../../components/CommonModal"
import services from '../../../assets/js/services';
export default {
  components: {
    Bread, CommonModal
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
      breadConfig: [
        { name: "实践案例" },
        { name: "案例台账" },
      ],
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        title: undefined,
        work_type: undefined,
        term: undefined,
        course_id: undefined,
        class_id: undefined,
        teacher_name: undefined,
        status: undefined,
      },
      statusArr: [
        { id: 1, name: '公开' },
        { id: 2, name: '隐藏' },
      ],
      workArr: [
        { id: 1, name: '大学生微电影' },
        { id: 2, name: '大学生讲思政课' },
      ],
      columns: [
        {
          title: "案例标题",
          dataIndex: "title",
        },
        {
          title: "作业类型",
          dataIndex: "work_type",
          scopedSlots: { customRender: 'work_type' },
        },
        {
          title: "所属班级",
          dataIndex: "class_name",
        },
        {
          title: "团队成员",
          dataIndex: "work_members",
        },
        {
          title: "指导教师",
          dataIndex: "teachers",
        },
        {
          title: "实践基地",
          dataIndex: "hub",
        },
        {
          title: "实践学期",
          dataIndex: "term_name",
        },
        {
          title: "实践课程",
          dataIndex: "course_name",
        },
        {
          title: "提交人",
          dataIndex: "created_name",
          width: '70px',
        },
        {
          title: "更新时间",
          dataIndex: "updated_at",
          width: '120px',
        },
        {
          title: "排序",
          dataIndex: "sort",
          width: '50px',
        },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: 'status' },
          width: '50px',
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      deleteVisible: false,
      hideVisible: false,
      openVisible: false,
      casesObj: null,
      downloadProgress: 0,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      activityTerm: state => state.teachEvent.activityTerm,
      trainCourse: state => state.teachEvent.trainCourse,
      activityClass: state => state.teachEvent.activityClass,
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  mounted () {
    // 获取学期数据
    this.getActivityTerm()
    // 获取实验课程
    this.getTrainCourse()
    // 获取实践班级列表
    this.getActivityClass({ page: 1, size: 999 })

    this.getTableList()
  },
  methods: {
    ...mapActions(["getActivityTerm", "getTrainCourse", "getActivityClass", "getCasesExcellentList", "getCasesExcellentExport"]),
    getTableList () {
      let params = {
        page: this.page,
        size: this.size,
        title: this.form.title,
        work_type: this.form.work_type,
        term: this.form.term,
        course_id: this.form.course_id,
        class_id: this.form.class_id,
        teacher_name: this.form.teacher_name,
        status: this.form.status,
      };
      this.getCasesExcellentList(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    onSearch () {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange (val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    // 预览优秀案例详情页
    linkExcellent (item) {
      console.log(item)
      const targetRoute = this.$router.resolve({
        path: `/${this.school_code}/worksshow/detail`,
        query: {
          id: item.id
        }
      });
      window.open(targetRoute.href, '_blank');

    },
    editExcellent (item) {
      this.casesObj = item
      console.log(item)
      this.$router.push({
        path: `/${this.school_code}/school/case/casepushform`,
        query: {
          cases_id: item.id, // 案例id
        }
      });
    },
    deleteExcellent (item) {
      this.casesObj = item
      this.deleteVisible = true
    },
    // 删除请求
    submitDelete () {
      let that = this
      services.putSchoolTrainCases({ id: that.casesObj.id, data: { _method: 'delete' } }).then(result => {
        this.deleteVisible = false
        if (result.code == "0000") {
          that.$message.success("删除成功")
          that.onSearch()
        } else {
          that.$message.error(result.message)
        }
      }).catch(() => {
        this.deleteVisible = false
      })
    },
    changeExcellent (item) {
      this.casesObj = item
      if (item.status == 2) {
        this.openVisible = true
      } else {
        this.hideVisible = true
      }
    },
    // 公开、隐藏 请求
    submitChangeStatus () {
      let that = this
      services.postSchoolCasesStatus({ id: that.casesObj.id, data: { _method: 'put', status: that.casesObj.status == 1 ? 2 : 1 } }).then(result => {
        if (that.casesObj.status == 2) {
          this.openVisible = false
        } else {
          this.hideVisible = false
        }
        if (result.code == "0000") {
          that.$message.success("操作成功")
          that.onSearch()
        } else {
          that.$message.error(result.message)
        }
      }).catch(() => {
        if (that.casesObj.status == 2) {
          this.openVisible = false
        } else {
          this.hideVisible = false
        }
      })
    },
    // 下载附件 请求
    downloadExcellent (obj) {
      let that = this
      if (that.tableData.length == 0) return that.$message.info("暂无数据")

      let params = {
        title: that.form.title,
        work_type: that.form.work_type,
        term: that.form.term,
        course_id: that.form.course_id,
        class_id: that.form.class_id,
        teacher_name: that.form.teacher_name,
        status: that.form.status,
      };

      if (obj) params.cases_id = obj.id
      that.getCasesExcellentExport(params).then((res) => {
        if (res.code == "0000" && res.data) {
          console.log(res.data)
          if (res.data.unique) {
            const targetRoute = that.$router.resolve({
              path: `/${that.school_code}/school/case/download`,
              query: {
                unique: res.data.unique,
              }
            });
            window.open(targetRoute.href, '_blank');
          }
        } else {
          that.$message.error(res.msg)
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>